export default function gtmConfig(country) {
  switch (country) {
    case 'fr':
      return 'GTM-KLXJVVC'
    default:
      return ''
  }
}
